import { render } from "./NotificationsDialog.vue?vue&type=template&id=aa56d210&scoped=true"
import script from "./NotificationsDialog.vue?vue&type=script&lang=js"
export * from "./NotificationsDialog.vue?vue&type=script&lang=js"

import "./NotificationsDialog.vue?vue&type=style&index=0&id=aa56d210&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa56d210"]])

export default __exports__